module.exports = __webpack_public_path__ + "img/packages/5.c7a8ff.png";